export enum NumberFormat {
  Currency = 'currency',
  Integer = 'integer',
  Decimal = 'decimal',
  Percentage = 'percentage',
  SocialSecurity = 'ssn',
  Zip = 'zip',
  Phone = 'phone',
}
const zipRegex = /(\d{5})(\d{4})/
const ssnRegex = /(\d{3})(\d{2})(\d{4})/

export type NumberRange = (number | null)[]

export const formatCurrency = (number: number, decimals = 2): string => {
  return `${new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: decimals,
  }).format(number)}`
}

export const formatInteger = (number: number): string => {
  return `${new Intl.NumberFormat('en-US').format(Math.round(number))}`
}

export const formatDecimal = (number: number, decimals = 2): string => {
  return `${new Intl.NumberFormat('en-US', {
    maximumFractionDigits: decimals,
  }).format(number)}`
}
export const formatZip = (number: number): string => {
  return `${number.toString().replace(zipRegex, '$1-$2')}`
}
export const formatSSN = (number: number): string => {
  return `${number.toString().replace(ssnRegex, '$1-$2-$3')}`
}

export const formatRange = (
  range: NumberRange,
  format: NumberFormat = NumberFormat.Decimal,
): string => {
  const formatFunction =
    format === NumberFormat.Currency
      ? formatCurrency
      : format === NumberFormat.Integer
        ? formatInteger
        : formatDecimal

  const hasStartRange = range[0] !== null
  const hasEndRange = range[1] !== null
  if (range[0] === range[1]) {
    return `${formatFunction(range[0] as number)}`
  } else if (hasStartRange && hasEndRange) {
    return `${formatFunction(range[0] as number)} - ${formatFunction(
      range[1] as number,
    )}`
  } else if (!hasStartRange && hasEndRange) {
    return `less than ${formatFunction(range[1] as number)}`
  } else {
    return `more than ${formatFunction(range[0] as number)}`
  }
}

export const formatPhoneNumber = (value: number, maxDigits = 15) => {
  if (!value) return value
  const phoneNumber = value.toString().replace(/[^\d]/g, '')
  const phoneNumberLength = phoneNumber.length
  if (phoneNumberLength < 4) return phoneNumber
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
  }
  if (phoneNumberLength <= 10) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6,
    )}-${phoneNumber.slice(6, maxDigits + 1)}`
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}-${phoneNumber.slice(10, maxDigits + 1)}`
}
